// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class SitePreferencesSet extends TrackingModel {
	public SitePreferencesSetId: number = 0;
	public PersonId: number = 0;
	public CloakTypeId: number = 0;
}